export default __webpack_public_path__ + "static/media/progresivos_desktop.f68154c2.svg";